import { render } from "./Sharp.svg?vue&type=template&id=3aee9d76"
const script = {}
script.render = render

export default script